<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
<h1>Donor Cycle Report</h1>

<p-card styleClass="single-inputs-only mb-2">
    <div class="formgrid grid">
        <div class="field col-12 sm:col-6 md:col-4 xxl:col-2">
            <label>Donor Type</label>
            <p-multiSelect [(ngModel)]="filters.donorTypes" [options]="data.donorTypes" placeholder="All"
                optionValue="key" optionLabel="value" [maxSelectedLabels]="1" appendTo="body"
                [displaySelectedLabel]="true" emptyMessage="No DonorTypes found"
                [selectedItemsLabel]="'{0} items selected'" [attr.data-cy]="'multi-select-State'">
                <ng-template let-option pTemplate="item">
                    <div class="inline-block vertical-align-middle">
                        <span class="ml-1 mt-1">
                            {{ option.value }}
                        </span>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xxl:col-2">
            <label>State</label>
            <p-multiSelect [(ngModel)]="filters.states" [options]="data.states" placeholder="All" optionValue="key"
                optionLabel="value" [maxSelectedLabels]="1" appendTo="body" [displaySelectedLabel]="true"
                emptyMessage="No states found" [selectedItemsLabel]="'{0} items selected'"
                [attr.data-cy]="'multi-select-State'">
                <ng-template let-option pTemplate="item">
                    <div class="inline-block vertical-align-middle">
                        <span class="ml-1 mt-1">
                            {{ option.value }}
                        </span>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xxl:col-2">
            <label>Donor Flag</label>
            <p-multiSelect [(ngModel)]="filters.donorFlags" [options]="data.donorFlags" placeholder="All"
                optionValue="key" optionLabel="value" [maxSelectedLabels]="1" appendTo="body"
                [displaySelectedLabel]="true" emptyMessage="No DonorFlags found"
                [selectedItemsLabel]="'{0} items selected'" [attr.data-cy]="'multi-select-State'">
                <ng-template let-option pTemplate="item">
                    <div class="inline-block vertical-align-middle">
                        <span class="ml-1 mt-1">
                            {{ option.value }}
                        </span>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xxl:col-2">
            <label>Fund Code</label>
            <p-multiSelect [(ngModel)]="filters.fundCodes" [options]="data.fundCodes" placeholder="All"
                optionValue="key" optionLabel="value" [maxSelectedLabels]="1" appendTo="body"
                [displaySelectedLabel]="true" emptyMessage="No DonorFlags found"
                [selectedItemsLabel]="'{0} items selected'" [attr.data-cy]="'multi-select-State'">
                <ng-template let-option pTemplate="item">
                    <div class="inline-block vertical-align-middle">
                        <span class="ml-1 mt-1">
                            {{ option.value }}
                        </span>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xxl:col-2">
            <label>Donation Source</label>
            <p-multiSelect [(ngModel)]="filters.donorSources" [options]="data.donorSources" placeholder="All"
                optionValue="key" optionLabel="value" [maxSelectedLabels]="1" appendTo="body"
                [displaySelectedLabel]="true" emptyMessage="No DonorFlags found"
                [selectedItemsLabel]="'{0} items selected'" [attr.data-cy]="'multi-select-State'">
                <ng-template let-option pTemplate="item">
                    <div class="inline-block vertical-align-middle">
                        <span class="ml-1 mt-1">
                            {{ option.value }}
                        </span>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
    </div>

    <div class="py-2 flex justify-content-end">
        <rc-generic-button label="Clear All" id="button-clear-filters" iconImg="clear-filter" borderStyle="outline"
            [classes]="['my-1']" data-cy="btn-clear" (click)="resetFilters()" />


        <rc-generic-button label="Search" id="button-search" iconImg="search" [classes]="['my-1 ml-1']"
            data-cy="btn-search" (click)="onSearch()" />

    </div>
</p-card>

<p-card>
    <div class="py-2 flex justify-content-end" *ngIf="tabledata.length >0">
        <p-button [disabled]="!hasResults" label="Export" icon="fa-sharp fa-light fa-download" id="button-export"
            styleClass="my-1" severity="secondary" (onClick)="exportToExcel()" class="ml-0"></p-button>
    </div>
    <div style="width: 100%; position: relative; min-height: 22rem;">
        <p-table #resultstable selectionMode="multiple" scrollHeight="flex" filter="false"
            [(selection)]="displayColumns" [columns]="displayColumns" styleClass="rc-datatable-outlined"
            [rows]="pagingModel.maxResults" [value]="tabledata" [exportHeader]="'customExportHeader'"
            [paginator]="!showLoading && hasResults && tabledata.length > pagingModel.maxResults"
            [sortField]="pagingModel.sortField" [sortOrder]="pagingModel.sortAsc"
            [rowsPerPageOptions]="[10, 25, 50, 100]" (onPage)="pageChange($event)" [scrollable]="true"
            [reorderableColumns]="false" id="table-data">

            <ng-template pTemplate="caption" style="min-height: 300px"></ng-template>
            <ng-template #defaultTableHeaderTemplate>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        @for (col of displayColumns; track col.columnName ){
                        <th *ngIf="col.visible" pSortableColumn={{col.columnName}} id="column-{{col.columnName}}"
                            style="vertical-align: top;" nowrap>
                            <div class="sortable-title">
                                <div class="column-title" [textContent]="col.displayColumn"></div>
                                <p-sortIcon [field]="col.columnName" style="cursor: pointer;" />
                            </div>
                        </th>
                        }
                    </tr>


                </ng-template>
            </ng-template>

            <!-- [(selection)]="selectedColumns" -->
            <ng-container [ngTemplateOutlet]="defaultTableHeaderTemplate">
            </ng-container>


            <ng-template pTemplate="body" let-item let-index="rowIndex" #defaultTableBodyTemplate>

                <tr *ngIf="!showLoading && hasResults">
                    <!-- [class]="getIsChecked(item, itemsChecked) ? 'selected' : ''" -->
                    @for (column of displayColumns; track $index ){
                    <td *ngIf="column.visible === true">
                        <span
                            *ngIf="column.columnName.toLowerCase().includes('date') && !column.columnName.toLowerCase().includes('amount')">
                            {{ getDisplayValue(item, column)
                            | date: 'MM/dd/yyyy' }}</span>
                        <span *ngIf="column.columnName.toLowerCase().includes('amount')"> {{ getDisplayValue(item,
                            column)
                            | currency: 'USD':'symbol' }}</span>
                        <span *ngIf="isFundCode(column.columnName)">
                            {{ getDisplayValue(item, column) | currency: 'USD':'symbol' }}
                        </span>
                        <span *ngIf="!column.columnName.toLowerCase().includes('amount')
                        && !column.columnName.toLowerCase().includes('date') && !isFundCode(column.columnName)"
                            [textContent]="getDisplayValue(item, column)"></span>
                    </td>
                    }

                </tr>

            </ng-template>

        </p-table>

        <div *ngIf="showLoading || !hasResults" ngClass="medium loader-wrapper">
            <div *ngIf="showLoading">
                <rc-loading-spinner></rc-loading-spinner>
            </div>
            <td *ngIf="!showLoading && !searchPerformed && !hasResults" colSpan={{tabledata.length}}
                class="text-center no-data-message">
                Please adjust filters and click Search to generate report.
            </td>
            <td *ngIf="!showLoading && searchPerformed && !hasResults" colSpan={{tabledata.length}}
                class="text-center no-data-message">
                No results available. Please adjust filters and try again.
            </td>
        </div>


    </div>

</p-card>